import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import AreaPage from "../pages/areas/AreaPage";
import { AREA_PAGES } from "../data/areas";

// Every route here is prerendered to static HTML at build time (see scripts/prerender.mjs).
// Link between pages with plain <a href>, not <Link>: a full page load picks up each page's own
// prerendered <head> (title, canonical, JSON-LD), which client-side navigation would not update.
const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  ...AREA_PAGES.map((area) => ({
    path: area.path,
    element: <AreaPage area={area} />,
  })),
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
